<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="headingAOWenANW1">
            <button aria-controls="collapseAOWenANW1" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapseAOWenANW1" data-bs-toggle="collapse" type="button">
                Premies volksverzekeringen (AOW, Anw, Wlz) en Zorgverzekeringswet (Zvw)
            </button>
        </h2>
        <div aria-labelledby="headingAOWenANW1" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapseAOWenANW1">
            <div class="accordion-body">
                Vul de vragen in als jij of je fiscaal partner in het aangiftejaar niet (volledig) in Nederland
                verzekerd waren voor
                volksverzekeringen. Dit is meestal het geval als je buiten Nederland werkt of als je als buitenlands
                belastingplichtige deels in Nederland werkt en daardoor verzekerd bent voor de premies
                volksverzekeringen (AOW, Anw, Wlz) en/of Zorgverzekeringswet (Zvw).
            </div>
        </div>
    </div>


    <div class="accordion-item">
        <h2 class="accordion-header" id="headingAOWenANW">
            <button aria-controls="collapseAOWenANW" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapseAOWenANW" data-bs-toggle="collapse" type="button">
                Periode van niet verzekerd
            </button>
        </h2>
        <div aria-labelledby="headingAOWenANW" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapseAOWenANW">
            <div class="accordion-body">
                <p>Vul de periode in waarin je in Nederland NIET verzekerd bent in het aangiftejaar.</p>
                <p>
                    Ben je in het aangiftejaar in verschillende periodes verzekerd? Vul dan een aaneengesloten periode
                    in die overeenkomt
                    met het totaal aantal dagen dat je verzekerd was. Houd hierbij rekening met het volgende:
                </p>
                <ul>
                    <li>reken voor een maand 30 dagen</li>
                    <li>begin met de 1e dag van de 1e periode</li>
                </ul>

                <p><strong>Voorbeeld</strong></p>
                <p>
                    Je werkte van 01-01-2025 tot en met 15-05-2025 in Nederland. Van 16-05-2025 tot en met 30-08-2025
                    werkte je in Duitsland. Van 01-09-2025 tot en met 31-12-2025 werkte je in Nederland.
                </p>
                <p>
                    Het totaal aantal verzekerde dagen in Nederland is 8 maanden en 15 dagen (van 01-01-2025 tot en met
                    15-05-2025 = 4 maanden en 15 dagen en van 01-09-2025 tot en met 31-12-2025 = 4 maanden). Als periode
                    waarin je in Nederland verzekerd NIET was, vul je in van 16-09-2025 tot en met 31-12-2025
                    (3 maanden en 15 dagen).
                </p>
            </div>
        </div>
    </div>


    <div class="accordion-item">
        <h2 class="accordion-header" id="headingVermindering">
            <button aria-controls="collapseVermindering" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapseVermindering" data-bs-toggle="collapse" type="button">
                Situaties vermindering premie-inkomen
            </button>
        </h2>
        <div aria-labelledby="headingVermindering" class="accordion-collapse collapse"
             data-bs-parent="#accordionExample"
             id="collapseVermindering">
            <div class="accordion-body">
                <p>
                    Werkte je een deel van het jaar buiten Nederland en ben je daardoor een deel van het jaar in
                    Nederland verzekerd voor de volksverzekeringen? Dan betaal je alleen premie over deze periode.
                </p>
                <p>Je kunt om vermindering van jouw premie-inkomen vragen als 1 van de volgende situaties voor jou
                    geldt:</p>
                <ul>
                    <li>Een deel van jouw inkomen valt volgens een internationale regeling onder de
                        socialezekerheidswetgeving van een ander land.
                    </li>
                    <li>Je betaalt over een deel van jouw inkomen premie voor een wettelijke ouderdoms- en
                        overlijdensverzekering in een ander land. Jouw premie-inkomen is nooit meer dan jouw totale
                        inkomen min de vermindering premie-inkomen.
                    </li>
                </ul>

                <p><strong>Voorbeeld</strong></p>
                <p>
                    Je werkte van 1 januari 2025 tot 1 juli 2025 in Nederland. Daarna werkte je van 1 juli 2025 tot en
                    met
                    31 december 2025 in jouw woonland. Omdat je in 2025 premieplichtig was in Nederland, moet je jouw
                    premie-inkomen aangeven over heel 2025. Maar je was slechts van 1 januari 2025 tot 1 juli 2025
                    premieplichtig in Nederland. Vul dan voor de vermindering het bedrag in van de inkomsten min de
                    aftrekbare uitgaven vanaf 1 juli 2025 tot en met 31 december 2025.
                </p>

                <p><strong>Berekening premie-inkomen volgens 1 van de 2 methoden</strong></p>
                <p>De Belastingdienst berekent jouw premie-inkomen volgens 1 van de volgende 2 methoden:</p>
                <ol>
                    <li>Jouw belastbare inkomen over het hele kalenderjaar min de inkomsten en aftrekbare uitgaven uit
                        de periode waarin je niet meer verzekerd bent. Belastbaar inkomen is het inkomen dat onder de
                        premieheffing voor de volksverzekeringen valt.
                    </li>
                    <li>Het maximum van € 38.441 (of € 40.502 als je geboren bent vóór 1 januari 1946) berekenen we
                        evenredig over de periode dat je in 2025 verplicht verzekerd bent.
                    </li>
                </ol>
                <p>De Belastingdienst berekent altijd volgens beide methodes en passen de methode toe die voor jou het voordeligst
                    is.</p>

                <p><strong>Voorbeeld</strong></p>
                <p>
                    Je woonde in Duitsland en werkte in loondienst in Nederland. Jouw loon was € 15.000. Op 1 augustus
                    stopte je met werken in Nederland en ging je in Duitsland werken. Je ontving daar een loon van €
                    25.000. Je betaalt over de 1e 7 maanden premie voor de volksverzekeringen.
                </p>
                <p><strong>Methode 1: Berekening vermindering</strong></p>
                <p>
                    De Belastingdienst vermindert jouw premie-inkomen met het inkomen over de periode dat je niet meer verzekerd bent
                    (periode van werken in Duitsland). Resultaat: € 40.000 - € 25.000 = € 15.000.
                </p>
                <p><strong>Methode 2: Berekening maximumpremie-inkomen evenredig aan de periode</strong></p>
                <p>
                    Het maximuminkomen waarover we in 2025 premie berekenen is € 38.441 (of € 40.502 als je geboren bent
                    vóór 1 januari 1946). Voor 210 dagen is het maximumpremie-inkomen dan 210/360 x € 38.441 = € 21.670
                    (of € 22.576 als je geboren bent vóór 1 januari 1946).
                </p>
                <p>In dit voorbeeld is methode 1 voor jou het voordeligst. De Belastingdienst stelt jouw premie-inkomen daarom vast
                    op € 15.000.</p>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button aria-controls="collapse1" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapse1" data-bs-toggle="collapse" type="button">
                Situaties correctie premie-inkomen
            </button>
        </h2>
        <div aria-labelledby="heading1" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapse1">
            <div class="accordion-body">
                Was je in het aangiftejaar in Nederland verplicht verzekerd voor de volksverzekeringen? En moest jij
                over diezelfde periode in een ander land over jouw inkomen premie voor de sociale zekerheid betalen? Of
                was je dit verschuldigd aan een volkenrechtelijke instantie, bijvoorbeeld de UNESCO of het
                Internationaal Strafhof? Dan kun je in de volgende situaties een correctie van jouw premie-inkomen
                krijgen:
                <ul>
                    <li>
                        Je krijgt een uitkering bij ouderdom en overlijden volgens de socialezekerheidswetgeving van een
                        ander land. Voor die uitkering betaal je in dat land premie.
                    </li>
                    <li>
                        Je valt volgens een internationale regeling naast de Nederlandse socialezekerheidswetgeving
                        ookonder
                        de wetgeving van het land waarin je werkt. Je werkt bijvoorbeeld in Nederland in loondienst enin
                        Belgiëals zelfstandige.
                    </li>
                    <li>
                        Jouw premie-inkomen is nooit meer dan je totale inkomen min het inkomen waarover je in een ander
                        land premie betaalt en bedraagt maximaal het jaarlijkse maximum-premieinkomen.
                    </li>

                </ul>

            </div>
        </div>
    </div>

</div>

